import { IUntypedQuery, Topics } from '@zaplify/common';

export class GetJobTitleSuggestionsQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly titles: string[]) {
        super();
    }
}
